import { CALL_ABLE_PORTAL_API } from '../../middleware/authHeaders'
import { ABLE_PORTAL_API_ROOT } from '../../config/api'

export const ABLE_PORTAL_GET_ROLES_REQUEST = 'ABLE_PORTAL_GET_ROLES_REQUEST'
export const ABLE_PORTAL_GET_ROLES_SUCCESS = 'ABLE_PORTAL_GET_ROLES_SUCCESS'
export const ABLE_PORTAL_GET_ROLES_FAILURE = 'ABLE_PORTAL_GET_ROLES_FAILURE'

export const getAblePortalRoles = () => dispatch =>
  dispatch({
    [CALL_ABLE_PORTAL_API]: {
      method: 'GET',
      endpoint: `${ABLE_PORTAL_API_ROOT}/roles`,
      types: [
        ABLE_PORTAL_GET_ROLES_REQUEST,
        ABLE_PORTAL_GET_ROLES_SUCCESS,
        ABLE_PORTAL_GET_ROLES_FAILURE,
      ],
    },
  })

// SELECTORS
export const selectAblePortalRoles = state => state.ablePortal.authorization.roles

// STATE
export const INITIAL_STATE = {
  roles: null,
}

// REDUCER
const authorization = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [ABLE_PORTAL_GET_ROLES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      roles: newPayload?.results,
    }),
  }[type]?.(state, payload) || state)

export default authorization
